import { Component } from "@theme/component";
//#region assets/volume-pricing.ts
/**
* Displays volume pricing table with expandable rows.
* Shows pricing tiers based on quantity thresholds.
*
* @extends {Component}
*/
var VolumePricingComponent = class extends Component {
	/**
	* Toggles the expanded state of the volume pricing table
	*/
	toggleExpanded() {
		this.classList.toggle("volume-pricing--expanded");
	}
};
if (!customElements.get("volume-pricing")) customElements.define("volume-pricing", VolumePricingComponent);
//#endregion
